import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import { toast } from "react-toastify";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  email_icon,
  eye_icon,
  toggle_off,
  toggle_on,
  view_icon,
} from "../../../assets/imgs";
import { Table } from "../../../components/Table/Table";
import {
  useAddAdminMutation,
  useCompanyManagerEditMutation,
  useLazyAdminStatusQuery,
  useLazyCompanyLocationListQuery,
  useLazyCompanyManagerQuery,
  useLazyDeleteAdminQuery,
  useLazyLocationListQuery,
  useLazyViewAdminQuery,
  useListAdminMutation,
  useListRoleMutation,
  useUpdateAdminMutation,
} from "../../redux/api/api";
import apiRequest from "../../redux/api/apiRequest";
import { EMAIL, PASS } from "../../redux/api/Constants";

const Manager = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const givenuser = JSON.parse(localStorage.getItem("user_details"));
  const [deletePopup, setDeletePopup] = useState("");
  const [selectedImage, setSelectedImage] = useState(dummyimage);
  const [images, setImages] = useState([]);
  const inputRef = useRef(null);
  const [banner, setBanner] = useState("");

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(event.target.files[0]);
  };
  const handleImageClick = () => {
    inputRef.current.click();
  };
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState(false);
  const [mobile, setMobile] = useState();
  const [personName, setPersonName] = useState();
  const [mail, setMail] = useState();
  const [location, setLocation] = useState();
  const [logo, setLogo] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [locList, setLoclist] = useState([]);
  const [rolesList, setRoleslist] = useState([]);
  const [admindetails, setAdminDetails] = useState({
    id: "",
    company_name: "",
    name: "",
    email: "",
    role_id: "",
    phone: "",
    password: "",
    password_confirmation: "",
    location: "",
    logo: "",
  });
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [addAdmin] = useAddAdminMutation();
  const [viewAdmin] = useLazyViewAdminQuery();

  const [listManager] = useLazyCompanyManagerQuery();
  const [companyLocationList] = useLazyCompanyLocationListQuery();
  const [updateManager] = useCompanyManagerEditMutation();

  const [adminStatus] = useLazyAdminStatusQuery();
  const [deleteAdmin] = useLazyDeleteAdminQuery();
  const [listRole] = useListRoleMutation();

  const getList = async (search) => {
    const res = await apiRequest(listManager);
    if (res?.status == "success") {
      let d = res?.data;
      setList(d);
      setSelectedImage(d?.logo);
      setLocation(d?.location);
      setPersonName(d?.name);
      setMobile(d?.phone);
      setPagination(res?.pagination_meta);
    }
  };
  const getLocationList = async () => {
    const res = await apiRequest(companyLocationList);
    if (res?.status == "success") {
      setLoclist(res?.data);
    }
  };

  useEffect(() => {
    getList();
    getLocationList();
    //   getRolesList();
  }, []);

  const AdminAdd = async () => {
    if (
      !personName ||
      password.length < 8 ||
      confirmPassword?.length < 8 ||
      !password.match(PASS) ||
      password != confirmPassword ||
      !selectedImage ||
      mobile?.length < 8
    ) {
      setError(true);
      return;
    }

    // if (!editMode) {
    // if (
    //     password.length < 8 ||
    //     confirmPassword?.length < 8 ||
    //     !password.match(PASS) ||
    //     password != confirmPassword
    // ) {
    //     setError(true);
    //     return;
    // }
    // }
    setError(false);
    const formdata = new FormData();
    formdata.append("company_name", list?.company_name);
    formdata.append("name", personName);
    formdata.append("phone", mobile);
    formdata.append("email", list?.email);
    if (password) {
      formdata.append("password", password);
    }
    if (confirmPassword) {
      formdata.append("password_confirmation", confirmPassword);
    }
    formdata.append("location", location);
    formdata.append("logo", selectedImage);

    setLoader(true);
    const res = await apiRequest(updateManager, formdata);
    setLoader(false);
    setAdminDetails({});
    setEditMode(false);
    if (res?.status == "success") {
      toast.success(res?.message);
    } else {
      toast.error("Error");
    }
    getList();
    setType(false);
  };

  // useEffect(() => {
  //   getList();
  // }, [page]);
  // console.log(page);

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    setAdminDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div className="dashRightView home_section">
      {/* <div className="d-flex ac-jb">
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                    Ninos IT Solution
                </h2>
            </div> */}

      {/* {popup && (
                <div className="popup-design">
                    <div className="popup"> */}
      {givenuser?.role?.id && (
        <div className="d-flex ac-je">
          <button
            onClick={() => {
              if (editMode) {
                setEditMode(false);
              }
              setType(!type);
            }}
            className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
          >
            Edit
          </button>
        </div>
      )}
      <div className="d-flex ac-js  flex-wrap gap-5">
        <div className="col-md-4">
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
            Company Name
          </h4>
          <input
            readOnly
            type="text"
            className="input-pop ps-2 w-100"
            placeholder="Name"
            name="name"
            onChange={(e) => {
              handleUpdate(e);
            }}
            value={list?.company_name}
          />
          {error && !list?.name && <p className="err mb-0">Enter Your Name</p>}
        </div>
        <div className="col-md-4">
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
            Primary Person Name
          </h4>
          <input
            readOnly={type ? false : true}
            type="text"
            className="input-pop ps-2 w-100"
            placeholder="Primary Person Name"
            name="name"
            onChange={(e) => {
              setPersonName(e.target.value);
            }}
            value={personName}
          />
          {error && !personName && (
            <p className="err mb-0">Enter Primary Person Name</p>
          )}
        </div>
        <div className="col-md-4">
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  ">
            Primary Email ID
          </h4>
          <input
            readOnly
            type="email"
            className="input-pop ps-2 w-100"
            placeholder=" Email Address"
            name="email"
            onChange={(e) => {
              handleUpdate(e);
            }}
            value={list?.email}
          />
          {error && (!list?.email || !list?.email.match(EMAIL)) && (
            <p className="err mb-0">Enter Valid Email</p>
          )}
        </div>
        <div className="col-md-4">
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  ">
            Primary Mobile Number
          </h4>
          <input
            readOnly={type ? false : true}
            type="number"
            className="input-pop ps-2 w-100"
            placeholder="Primary Mobile Number"
            name="phone"
            onChange={(e) => {
              if (e.target.value?.length <= 8) {
                setMobile(e.target.value);
              }
            }}
            value={mobile}
          />
          {error && list?.phone?.length < 8 && (
            <p className="err mb-0">Enter Valid Phone Number</p>
          )}
        </div>
        <div className="col-md-4">
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  ">
            Primary Password
          </h4>
          <div className="input-pop mb-2 w-100 d-flex ac-jb">
            <input
              readOnly={type ? false : true}
              type={visible ? "text" : "password"}
              maxLength={20}
              className="cust-btn  w-90"
              placeholder="Password"
              name="password"
              autoComplete="off"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              value={password}
            />
            <img
              src={eye_icon}
              onClick={() => setVisible(!visible)}
              className="eye-icon pointer"
              alt=""
            />
          </div>
          {error &&
            // !editMode &&
            (password?.length < 8 || password?.match(PASS)) && (
              <p className="err">
                {!password
                  ? "Enter Your password"
                  : !password?.match(PASS)
                  ? "Must include one special char & capital leteer"
                  : "Enter Minimum 8 Characters"}
              </p>
            )}
        </div>
        <div className="col-md-4">
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  ">
            Confirm Primary Password
          </h4>
          <div className="input-pop mb-2 w-100 d-flex ac-jb">
            <input
              readOnly={type ? false : true}
              type={visible ? "text" : "password"}
              maxLength={20}
              className="cust-btn w-90"
              placeholder=" Confirm Password"
              name="password_confirmation"
              autoComplete="off"
              onChange={(e) => {
                setConfirmPassword(e.target.value);
              }}
              value={confirmPassword}
            />
            <img
              src={eye_icon}
              onClick={() => setVisible(!visible)}
              className="eye-icon pointer"
              alt=""
            />
          </div>
          {error &&
            // !editMode &&
            (confirmPassword?.length < 8 || password != confirmPassword) && (
              <p className="err mb-0">
                {!confirmPassword
                  ? "Enter Confirm Password"
                  : confirmPassword?.length < 8
                  ? "Enter Minimum 8 Characters"
                  : "Password Mismatch"}
              </p>
            )}
        </div>

        <div className="col-md-4">
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
            Roles
          </h4>
          <input
            className="input-pop ps-2 w-100"
            name="role_id"
            placeholder="Comapny Manager"
            onChange={(e) => {
              handleUpdate(e);
            }}
            value={list?.role_name}
            readOnly
          />
          {/* <select 
                            className="input-pop ps-2 w-100"
                            name="role_id"
                            onChange={(e) => {
                                handleUpdate(e);
                            }}
                            value={admindetails?.role_id}
                            disabled
                        >
                            <option value={""}> -- Select --</option>
                            {rolesList?.map((item) => {
                                return <option value={item?.id}> {item?.name}</option>;
                            })}
                        </select> */}
          {/* {error && !admindetails?.role_id && (
                        <p className="err mb-0">Select Your Role</p>
                    )} */}
        </div>
        <div className="col-md-4">
          <div>
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
              Location
            </h4>
            <select
              disabled
              name="location"
              value={location}
              onChange={(e) => {
                setLocation(e.target.value);
              }}
              className="input-pop ps-2 w-100"
            >
              <option>Select Location</option>
              {locList.map((item) => {
                return <option value={item?.id}>{item?.name}</option>;
              })}
            </select>
            {/* {error && !admindetails?.location && (
                            <p className="err mb-0">Enter Your Location </p>
                        )} */}
          </div>
        </div>
        <div className="col-md-4">
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  ">
            Company Logo Upload
          </h4>
          <div className="input-pop mb-2 w-100 d-flex ac-jb">
            <div onClick={handleImageClick} className="position-relative w-100">
              <div className="d-flex ac-jb w-100">
                {/* <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  ">
                                        Choose Upload Image
                                    </h4> */}
                <div>
                  {typeof selectedImage === "string" ? (
                    <img
                      alt="not found"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "10px",
                      }}
                      src={selectedImage ? selectedImage : dummyimage}
                    />
                  ) : selectedImage?.name ? (
                    <img
                      alt="not found"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "10px",
                      }}
                      src={URL.createObjectURL(selectedImage)}
                    />
                  ) : (
                    <img
                      alt="not found"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "10px",
                      }}
                      src={dummyimage}
                    />
                  )}
                  <input
                    disabled={type ? false : true}
                    style={{
                      position: "absolute",
                      width: "40px",
                      height: "40px",
                      left: "0px",
                      top: "0px",
                    }}
                    type="file"
                    hidden
                    name="myImage"
                    accept="image/*"
                    ref={inputRef}
                    onChange={handleImageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {type && (
        <div className="d-flex ac-je">
          <button
            onClick={() => {
              AdminAdd();
            }}
            className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
          >
            {loader && (
              <div
                class="spinner-border spinner-border-sm "
                role="status"
                style={{ marginRight: "5px" }}
              ></div>
            )}
            Submit
          </button>
        </div>
      )}
      {/* </div>
                </div>
            )} */}

      {/* <Table
                columns={columns}
                setPageno={setPage}
                pagecount={pagination}
                data={list}
                show={true}
            /> */}
    </div>
  );
};

export default Manager;
